import axios from '../../utils/axios'

const prefix = 'exams/bundles-evaluation-digital/admin'

const appendUrl = (path: string[] | string) => {
  if (typeof path === 'string') {
    return `${prefix}/${path}`
  }
  return [prefix, ...path].join('/')
}

export const adminBundleEvaluation = {
  async getInstitutions() {
    const res = await axios.get(appendUrl('institutions'))
    return res.data as { id: number; name: string; code: string }[]
  },

  async getExaminations(params: {
    examCategory?: string
    search?: string
    courseId?: number
    regulationId?: number
    semNo?: number
    institutionId?: number
    limit?: number
    offset?: number
  }) {
    const res = await axios.get(appendUrl('examinations'), { params })
    return res.data
  },

  async getExamSubjects(
    examGroupId: number | string,
    params?: {
      examCategory?: string
      search?: string
      branchCode?: string
      date?: string
      limit?: number
      offset?: number
    },
  ) {
    const res = await axios.get(
      appendUrl(['examinations', `${examGroupId}`, 'subjects']),
      {
        params,
      },
    )
    return res.data
  },

  async getBundles(
    examGroupId: number | string,
    params: {
      examCategory?: string
      subjectCode?: string
      evaluationId?: string
      group1Key?: string
      date?: string
      fromTimeString?: string
      toTimeString?: string
      bundleType?: 'Evaluation' | 'Revaluation'
      search?: string
      limit?: number
      offset?: number
    },
  ) {
    const res = await axios.get(
      appendUrl(['subjects', `${examGroupId}`, 'bundles']),
      {
        params,
      },
    )
    return res.data
  },

  async getBundleBooklets(bundleId: number | string) {
    const res = await axios.get(
      appendUrl(['bundles', `${bundleId}`, 'booklets']),
    )
    return res.data
  },

  async getInternalBundleBooklets(params: {
    evaluationId: string
    evaluationBundleId: string
  }) {
    const res = await axios.get(appendUrl('internal-bundle-booklets'), {
      params,
    })
    return res.data
  },

  async getInternalBookletDetail(params: {
    evaluationId: string
    evaluationBundleId: string
    evaluationBookletId: string
  }) {
    const res = await axios.get(appendUrl('internal-booklet'), { params })
    return res.data
  },

  async getBookletDetail(params: {
    bundleId: number | string
    studExternalId: number | string
  }) {
    const res = await axios.get(appendUrl('booklet'), {
      params,
    })
    return res.data
  },
}
